import { ConsoleLogger } from 'framework-ui-components';

const Log = new ConsoleLogger('FW-PLUGINS');
Log.init(process.env.NODE_ENV !== 'production' ? ConsoleLogger.LogLevel.all : ConsoleLogger.LogLevel.none);

export default Log;
